export default __webpack_public_path__ + "static/media/controls_total_controls.709600d8.svg";